import { render, staticRenderFns } from "./SurveyQuestionItem.vue?vue&type=template&id=0a425c72&"
import script from "./SurveyQuestionItem.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports